import { Steps } from 'antd'
import React, { FunctionComponent } from 'react'

import { buybackSteps } from '../../../common/buybackTypes'

export interface BuybackFormStepBarProps {
  setCurrent: (step: number) => void
  current: number
}

const items = buybackSteps.map(item => ({ key: item.title, title: item.title }))

export const BuybackFormStepBar: FunctionComponent<BuybackFormStepBarProps> =
  props => (
    <Steps
      type="navigation"
      size="small"
      onChange={props.setCurrent}
      current={props.current}
      items={items}
    />
  )
